import { Link } from 'react-router'

export function BugMark({ size = 26 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" aria-hidden="true">
      <path
        d="M9.2 8.1 6.3 5.2M18.8 8.1l2.9-2.9M7.3 12.2H3.6M24.4 12.2h-3.7M7.3 18.1H3.6M24.4 18.1h-3.7M9.2 21l-2.9 2.9M18.8 21l2.9 2.9"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M9 10.8C9 7.9 11.2 5.6 14 5.6s5 2.3 5 5.2v7.1c0 3-2.2 5.3-5 5.3S9 20.9 9 17.9v-7.1Z"
        fill="currentColor"
      />
      <path d="M14 6v17M9.5 13.2h9" stroke="var(--bg)" strokeWidth="1.4" />
    </svg>
  )
}

export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <Link to="/" className="brand" aria-label="bug.engineering home">
      <span className="brand-mark">
        <BugMark />
      </span>
      {!compact && (
        <span className="brand-type">
          <strong>bug</strong>
          <span>.engineering</span>
        </span>
      )}
    </Link>
  )
}
